'use client';

import { GoogleAnalytics } from '@next/third-parties/google';
import { usePathname } from 'next/navigation';

interface ConditionalAnalyticsProps {
  gaId: string;
}

/**
 * ConditionalAnalytics component that excludes Google Analytics tracking
 * from admin routes (/admin/*) for privacy and to prevent admin activity
 * from affecting analytics data.
 */
export default function ConditionalAnalytics({ gaId }: ConditionalAnalyticsProps) {
  const pathname = usePathname();
  
  // Don't load analytics on admin routes
  const isAdminRoute = pathname?.startsWith('/admin');
  
  if (isAdminRoute) {
    return null;
  }
  
  return <GoogleAnalytics gaId={gaId} />;
}
